export default function getBadgeProps(source: string) {
  const clientBadge = source === 'Client';
  return {
    source,
    badgeType: clientBadge ? 'PRIMARY' : source,
    badgeText: clientBadge ? 'life-id.manually' : source,
    skipBadgeTranslation: !clientBadge,
  };
}
